export default __webpack_public_path__ + "static/media/geotabLogo.ae058e37.jpg";